module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Regular.f309e4fe.woff";